import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
//Limitless imports
import { subscribeToUserChannel, unsubscribeFromUserChannel } from "../../utils/WebSocketHelper";
import { log as pilog, WSClient } from "@limitless/common/utils";
import { useNotificationContext } from "@limitless/common/hooks";
const win = typeof window === "undefined" ? {} : window;
win.Paho = {
  MQTT: WSClient
};
export const USER_ROLE = "userRole";
export const USER = "user";
const SIGN_OUT_WS_ACTION = "sign-out";
const EXPORT_COMPLETE_ACTION = "exportComplete";
const EXPORT_FAILED_ACTION = "exportFailed";
export const useCommonPortalWebSocketHook = () => {
  const log = pilog.getLogger("useCommonPortalWebSocketHook");
  const {
    profile,
    setSecurityProfileChanged
  } = useExpertProfileContext();
  const {
    addFailureNotification,
    addSuccessNotification
  } = useNotificationContext();
  const processWebSocketEvent = event => {
    logEvent(event, true);
    switch (event.type) {
      case USER_ROLE:
        if (event.action === SIGN_OUT_WS_ACTION && profile.userName) {
          setSecurityProfileChanged(true);
        }
        break;
      case USER:
        if (event.action === EXPORT_COMPLETE_ACTION && profile.userName) {
          addSuccessNotification("Export Complete");
        }
        if (event.action === EXPORT_FAILED_ACTION && profile.userName) {
          addFailureNotification("Export failed, please contact support");
        }
        break;
      default:
        {
          log.info(`Unsupported Common event type: ${event.type}`);
        }
    }
  };
  const logEvent = (event, shouldProcess, ...rest) => {
    if (process.env.REACT_APP_WS_HISTORY) {
      if (shouldProcess) {
        window.wsEvents.push({
          event,
          ...rest,
          userName: profile.userName
        });
      } else {
        window.wsEventsRejected.push({
          event
        });
      }
    }
  };
  const onConnect = client => {
    subscribeToUserChannel(client, profile);
  };
  const onDisconnect = client => {
    try {
      unsubscribeFromUserChannel(client, profile);
    } catch (error) {
      log.info("Failed to unsubscribe from web sockets %o ", error);
    }
  };
  return {
    logEvent,
    onConnect,
    onDisconnect,
    processWebSocketEvent
  };
};